import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ControlDto } from './../models/vehicle-control';
import { VehicleControlService } from './vehicle-control.services';

@Injectable()
export class VehicleControlListByVehicleResolver
{
  constructor(private backend: VehicleControlService) {}
  resolve(route: ActivatedRouteSnapshot): Observable<ControlDto[]> {
    return this.backend.getVehicleControlByVehicleId(+route.params['Id']);
  }
}

@Injectable()
export class VehicleControlEditResolver {
  constructor(private backend: VehicleControlService) {}
  resolve(route: ActivatedRouteSnapshot): Observable<ControlDto> {
    if (+route.params['id'] > 0) {
      return this.backend.getVehicleControlById(+route.params['id']);
    } else {
      return null;
    }
  }
}
